import axios from 'axios';

// Use VITE_ prefixed environment variables
// In production, these come from .env.production
// In development, defaults to /api for local dev with Vite proxy
const baseURL = import.meta.env.VITE_API_URL || '/api';

console.log('API Client initialized with baseURL:', baseURL, '(env:', import.meta.env.MODE, ')');

const client = axios.create({
  baseURL,
  withCredentials: true, // Send cookies with requests
});

// Add request interceptor to include token in Authorization header if it exists
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('rdf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

export default client;
